import { useState, useEffect } from 'react';

/**
 * Custom hook for drag-and-drop functionality
 * Handles drag state and reordering logic
 */
export const useDragAndDrop = (initialItems, onReorder) => {
  const [items, setItems] = useState(initialItems);
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedOverItem, setDraggedOverItem] = useState(null);

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  const handleDragStart = (e, item, index) => {
    setDraggedItem({ item, index });
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', e.target);
    
    // Add dragging class for visual feedback
    setTimeout(() => {
      e.target.classList.add('dragging');
    }, 0);
  };

  const handleDragEnd = (e) => {
    e.target.classList.remove('dragging');
    setDraggedItem(null);
    setDraggedOverItem(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDragEnter = (e, item, index) => {
    e.preventDefault();
    setDraggedOverItem({ item, index });
  };

  const handleDrop = (e, dropItem, dropIndex) => {
    e.preventDefault();
    e.stopPropagation();

    if (!draggedItem || draggedItem.index === dropIndex) {
      return;
    }

    const newItems = [...items];
    const draggedItemContent = newItems[draggedItem.index];
    
    // Remove dragged item
    newItems.splice(draggedItem.index, 1);
    
    // Insert at new position
    const insertIndex = draggedItem.index < dropIndex ? dropIndex - 1 : dropIndex;
    newItems.splice(insertIndex, 0, draggedItemContent);

    setItems(newItems);
    
    // Notify parent component
    if (onReorder) {
      onReorder(newItems);
    }

    setDraggedItem(null);
    setDraggedOverItem(null);
  };

  return {
    items,
    draggedItem,
    draggedOverItem,
    handleDragStart,
    handleDragEnd,
    handleDragOver,
    handleDragEnter,
    handleDrop
  };
};
